module.exports = __webpack_public_path__ + "media/images/banner/2-d3f04cdce3a3ff0413dbbd50a83ac02a.jpg";